import React, { useState } from "react";
import { Button } from "react-bootstrap";
import NewAboutChild from "./NewAboutChild";

const NewAbout = () => {
  const [AboutState, setAboutState] = useState("About");
  return (
    <div className="projects-main">
      <div
        className="d-flex flex-wrap justify-content-center
    align-items-center tab-btn mb-5 "
      >
        <Button
          variant={` me-3 mb-3 ${
            AboutState === "About" ? " btn-main-btn" : ""
          }`}
          onClick={(e) => setAboutState("About")}
        >
          About
        </Button>
        <Button
          variant={` me-3 mb-3 ${
            AboutState === "Education" ? " btn-main-btn" : ""
          }`}
          onClick={(e) => setAboutState("Education")}
        >
          Education
        </Button>
        <Button
          variant={` me-3 mb-3 ${
            AboutState === "Awards" ? " btn-main-btn" : ""
          }`}
          onClick={(e) => setAboutState("Awards")}
        >
          Awards
        </Button>
        <Button
          variant={` me-3 mb-3 ${
            AboutState === "Certificates" ? " btn-main-btn" : ""
          }`}
          onClick={(e) => setAboutState("Certificates")}
        >
          Certificates
        </Button>
        <Button
          variant={` me-3 mb-3 ${
            AboutState === "Languages" ? " btn-main-btn" : ""
          }`}
          onClick={(e) => setAboutState("Languages")}
        >
          Languages
        </Button>
        <Button
          variant={` me-3 mb-3 ${
            AboutState === "Interests" ? " btn-main-btn" : ""
          }`}
          onClick={(e) => setAboutState("Interests")}
        >
          Interests
        </Button>

        <Button
          variant={` me-3 mb-3 ${
            AboutState === "Expertise" ? " btn-main-btn" : ""
          }`}
          onClick={(e) => setAboutState("Expertise")}
        >
          Expertise
        </Button>
      </div>
      <NewAboutChild type={AboutState} />
    </div>
  );
};

export default NewAbout;
